import { SisccWebApi } from "../generated/apis/SisccWebApi";
import { Configuration, ConfigurationParameters } from "../generated/runtime";
import isDev from "../../utilities/environmentUtils";

import Constants from "../../constants";

const serviceUrl = new URLSearchParams(window.location.search).get(Constants.serviceUrlQueryParam);
const configurationParameters: ConfigurationParameters = {
    basePath:
        serviceUrl ||
        (isDev()
            ? Constants.defaultServiceUrlLocalhost
            : window.location.href.substring(0, window.location.href.indexOf(Constants.configuratorUrlPath))),
};
export const configuration = new Configuration(configurationParameters);
const client = new SisccWebApi(configuration);

export default client;
